export const SocialData = [
    {
        id: 1,
        platform: 'Instagram',
        link: 'https://www.instagram.com/ankitchoudhary8322/',
        icon: require('../../assets/icons/instagram.png').default,
    },
    {
        id: 2,
        platform: 'Github',
        link: 'https://github.com/ankit1509',
        icon: require('../../assets/icons/github.png').default,
    },
    {
        id: 3,
        platform: 'Linkedin',
        link: 'https://www.linkedin.com/in/vcf-ankitchoudhary/',
        icon: require('../../assets/icons/linkedin.png').default,
    },
    {
        id: 4,
        platform: 'Facebook',
        link: 'https://www.facebook.com/profile.php?id=100050947037945',
        icon: require('../../assets/icons/facebook.png').default,
    }
]